"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedAppeasement = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
class RedAppeasement extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.RED_APPEASEMENT,
            cost: 0,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.REDS)),
            metadata: {
                cardNumber: 'P80',
                description: 'Requires that Reds are ruling or that you have 2 delegates there, AND THAT NO OTHER PLAYER HAS PASSED. Increase your M€ production 2 steps. This counts as passing, you get no more turns this generation.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(2)).nbsp().text('PASS').asterix();
                }),
            },
        });
    }
    canPlay(player) {
        const passedPlayers = player.game.getPassedPlayers();
        if (passedPlayers.length > 0)
            return false;
        const turmoil = player.game.turmoil;
        if (turmoil !== undefined) {
            if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.REDS)) {
                return turmoil.canPlay(player, PartyName_1.PartyName.REDS);
            }
            return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
        }
        return false;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.pass();
        return undefined;
    }
}
exports.RedAppeasement = RedAppeasement;
//# sourceMappingURL=RedAppeasement.js.map